import Navbar from "../components/Navbar";
import "../styles/Home.css";
import { Helmet } from "react-helmet-async";
export default function About() {
  return (
    <>
     

      {/* Founder Section */}
<Helmet>
<script type="application/ld+json">
{JSON.stringify({
"@context":"https://schema.org",
"@type":"Person",

"@id":"https://almondsoftwares.in/about#lucky-ali-memon",

"name":"Lucky Ali Memon",

"jobTitle":"Founder",

"description":
"Lucky Ali Memon is the founder of Almond Softwares, a technology company specializing in Salesforce development, React applications, Shopify ecommerce solutions and custom software.",

"url":"https://almondsoftwares.in/about",

"worksFor":{
"@type":"Organization",
"name":"Almond Softwares",
"url":"https://almondsoftwares.in"
},

"sameAs":[
"https://www.linkedin.com/in/luckyali47"
]

})}
</script>
</Helmet>

<section className="section">
  <div className="container">

    <h2 className="section-title">
      Founder
    </h2>

    <div
      style={{
        maxWidth: "850px",
        margin: "auto",
        textAlign: "center",
        padding: "48px 36px",
        borderRadius: "32px",
        background: "rgba(13, 19, 36, 0.7)",
        backdropFilter: "blur(28px) saturate(190%)",
        WebkitBackdropFilter: "blur(28px) saturate(190%)",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        boxShadow: "0 30px 70px -15px rgba(0, 0, 0, 0.8), inset 0 1px 1.5px rgba(255, 255, 255, 0.22)"
      }}
    >

      <h3
        style={{
          fontSize: "36px",
          fontWeight: "800",
          marginBottom: "18px",
          background: "linear-gradient(135deg, #60a5fa, #a78bfa, #34d399)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontFamily: "'Space Grotesk', sans-serif"
        }}
      >
        Almond Softwares
      </h3>

      <p
        style={{
          fontSize: "18px",
          lineHeight: "1.8",
          color: "#cbd5e1",
          maxWidth: "700px",
          margin: "auto"
        }}
      >
        Founded by{" "}
        <strong style={{ color: "#60a5fa" }}>
          Lucky Ali Memon
        </strong>{" "}
        in 2024, Almond Softwares helps businesses build modern software
        solutions using Salesforce, React, Shopify and emerging technologies.
      </p>


      <div
        style={{
          marginTop:"35px"
        }}
      >

        <a
          href="/founder"
          style={{
            position:"relative",
            display:"inline-flex",
            alignItems:"center",
            gap:"12px",

            padding:"16px 38px",

            borderRadius:"50px",

            background:
            "linear-gradient(135deg,#2563eb,#4f46e5,#06b6d4)",

            color:"#fff",

            textDecoration:"none",

            fontSize:"16px",
            fontWeight:"700",

            letterSpacing:"0.4px",

            boxShadow:
            "0 20px 45px rgba(37,99,235,0.35)",

            transition:
            "all .4s ease",

            transform:"translateY(0)"
          }}

          onMouseEnter={(e)=>{
            e.currentTarget.style.transform=
            "translateY(-8px) scale(1.05)";

            e.currentTarget.style.boxShadow=
            "0 30px 70px rgba(37,99,235,0.55)";
          }}

          onMouseLeave={(e)=>{
            e.currentTarget.style.transform=
            "translateY(0) scale(1)";

            e.currentTarget.style.boxShadow=
            "0 20px 45px rgba(37,99,235,0.35)";
          }}
        >

          Meet Our Founder

          <span
            style={{
              fontSize:"22px",
              transition:"transform .3s ease"
            }}
          >
            →
          </span>

        </a>

      </div>


    </div>

  </div>
</section>
 
      {/* Expertise */}

      <section className="section">
        <div className="container">

          <h2 className="section-title">Expertise</h2>

          <div className="services">

            <div className="service-card">
              <h3>Salesforce Solutions</h3>
              <p>
                Apex, Triggers, Batch Apex, Lightning Web Components (LWC),
                security & sharing model, API integrations, Flows,
                Salesforce-to-Salesforce integrations and third-party systems.
              </p>
            </div>

            <div className="service-card">
              <h3>React JS Development</h3>
              <p>
                High-performance websites, admin dashboards,
                REST API integrations, SPA architecture,
                and scalable frontend systems for startups and enterprises.
              </p>
            </div>

            <div className="service-card">
              <h3>Shopify eCommerce Development</h3>
              <p>
                Custom theme development, product page architecture,
                payment gateway integrations, checkout optimization,
                wishlist tools and conversion-focused store design.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Timeline */}

      <section className="section">
        <div className="container">

          <h2 className="section-title">Journey</h2>

          <div style={{maxWidth:"700px",margin:"auto"}}>

            <div style={{marginBottom:"30px"}}>
              <h4>2018 – 2022</h4>
              <p style={{color:"#555"}}>
                Bachelor of Engineering (Computer Science) — strong
                foundation in system design, architecture,
                and scalable application development.
              </p>
            </div>

            <div style={{marginBottom:"30px"}}>
              <h4>2022 – 2024</h4>
              <p style={{color:"#555"}}>
                Salesforce Developer working on enterprise automation,
                Lightning Web Components, Apex Triggers,
                integrations, and CRM optimization.
              </p>
            </div>

            <div>
              <h4>Founded · 2024</h4>
              <p style={{color:"#555"}}>
      Founded Almond Software in 2024, building scalable digital products,
Salesforce solutions, React applications, Shopify ecommerce platforms,
and Android applications for businesses and consumers.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Certifications */}

      <section className="section">
        <div className="container">

          <h2 className="section-title">Certifications</h2>

          <div className="tech-stack">

            <div className="tech">Platform Developer I</div>
            <div className="tech">Platform Developer II</div>
            <div className="tech">AI Associate</div>
            <div className="tech">Process Automation</div>
            <div className="tech">Security & Privacy</div>
            <div className="tech">Agentforce Specialist</div>

          </div>

        </div>
      </section>

      {/* Mission Vision */}

      <section className="section">
        <div className="container">

          <h2 className="section-title">About Almond Softwares</h2>

          <div className="services">

            <div className="service-card">
              <h3>Our Mission</h3>
              <p>
                To build scalable, secure, and automation-driven digital
                systems that align with real business objectives and deliver
                measurable impact.
              </p>
            </div>

            <div className="service-card">
              <h3>Our Vision</h3>
              <p>
                To become a trusted technology partner for startups and
                enterprises seeking high-performance Salesforce, React,
                and eCommerce solutions.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Contact */}

      <section className="section">
        <div className="container" style={{textAlign:"center"}}>

          <p style={{fontSize:"18px"}}>📧 luckymemon2234@gmail.com</p>

      <p style={{ marginTop: "15px", fontWeight: "500" }}>
  Visit Full Portfolio →
</p>

<div style={{ marginTop: "20px" }}>
  <a className="btn-primary" href="https://luckyali.web.app/">
    Website
  </a>
</div>

        </div>
    

      {/* Footer */}

      <footer className="footer">
        <div className="container">

          <p>© 2024 AlmondSoftware. All rights reserved.</p>

          <p style={{marginTop:"10px"}}>
            Engineering digital products with intelligence
          </p>

        

        </div>
      </footer>
  </section>
    </>
  );
}